import Pusher from "pusher-js";

const pusher = new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
  cluster: import.meta.env.VITE_PUSHER_CLUSTER,
  wsHost: import.meta.env.VITE_PUSHER_WS_HOST,
  wsPort: Number(import.meta.env.VITE_PUSHER_WS_PORT),
  wssPort: Number(import.meta.env.VITE_PUSHER_WS_PORT),
  forceTLS: import.meta.env.VITE_PUSHER_FORCE_TLS === "true",
  enabledTransports: ["ws", "wss"],
  authEndpoint: import.meta.env.VITE_PUSHER_AUTH_ENDPOINT,
  auth: {
    // Додаємо withCredentials: true, щоб браузер надсилав кукі з крос-доменними запитами
    withCredentials: true,
    // Якщо потрібні додаткові заголовки (наприклад, для CSRF токена), додайте їх тут:
    // headers: {
    //   'X-CSRF-TOKEN': 'your-csrf-token', // Приклад: отримайте з мета-тега або іншого джерела
    // },
  },
});

const channel = pusher.subscribe("private-base-match");
channel.bind("my-event", (data) => {
  console.log("Отримано:", data);
});

const subscribeToChannel = (channelName, eventName, callback) => {
  // Перевіряємо, чи канал вже підписаний, щоб уникнути повторної підписки
  let channel = pusher.channel(channelName);
  if (!channel) {
    channel = pusher.subscribe(channelName);
    console.log(`Підписано на канал: ${channelName}`);
  }

  // Прив'язуємо обробник події
  channel.bind(eventName, callback);
  console.log(`Прив'язано подію '${eventName}' до каналу '${channelName}'`);

  return channel;
};

const unsubscribeFromChannel = (
  channelName,
  eventName = null,
  callback = null,
) => {
  const channel = pusher.channel(channelName);

  if (channel) {
    if (eventName && callback) {
      // Відв'язати конкретний обробник події
      channel.unbind(eventName, callback);
      console.log(`Відв'язано подію '${eventName}' з каналу '${channelName}'`);
    } else {
      // Відписатися від усього каналу
      pusher.unsubscribe(channelName);
      console.log(`Відписано від каналу: ${channelName}`);
    }
  } else {
    console.warn(`Канал '${channelName}' не знайдено або не підписано.`);
  }
};

export { pusher, channel, subscribeToChannel, unsubscribeFromChannel };
